<template>
  <div class="product-page">
    <div class="search">
      <el-form
        :inline="true"
        class="query-form"
        @submit.native.prevent
      >
        <el-row
          :gutter="20"
          class="query-row"
        >
          <el-col
            :xs="24"
            :sm="12"
            :md="queryKeywordSpan"
            class="query-item"
          >
            <el-form-item>
              <el-input
                v-model.trim="query.form.keyword"
                clearable
                style="width: 100%"
                placeholder="请输入编号/产品名称/包名/DP"
                @keyup.enter.native="handleFilter"
              />
            </el-form-item>
          </el-col>

          <el-col
            :xs="24"
            :sm="12"
            :md="queryStatusSpan"
            class="query-item"
          >
            <el-form-item>
              <el-select
                v-model="query.form.status"
                clearable
                style="width: 100%"
                placeholder="产品状态"
              >
                <el-option
                  v-for="item in StatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col
            :xs="24"
            :sm="12"
            :md="queryAuditStatusSpan"
            class="query-item"
          >
            <el-form-item>
              <el-select
                v-model="query.form.audit_status"
                clearable
                style="width: 100%"
                placeholder="审核状态"
              >
                <el-option
                  v-for="item in AuditStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col
            :xs="24"
            :sm="24"
            :md="queryActionSpan"
            class="query-item query-item--actions"
          >
            <div class="query-buttons">
              <el-button
                plain
                type="primary"
                :loading="table.loading"
                @click="handleReset"
              >
                重置
              </el-button>

              <el-button
                type="primary"
                :loading="table.loading"
                @click="handleFilter"
              >
                查询
              </el-button>

              <!-- <el-button
                type="text"
                class="query-toggle"
                @click="toggleQueryExpand"
              >
                {{ queryExpanded ? '收起' : '展开' }}
                <i :class="queryExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
              </el-button> -->
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <section
      v-loading="table.loading"
      aria-label="产品列表"
    >
      <div class="table-header-actions">
        <el-button
          type="primary"
          @click="handleAdd"
        >
          添加
        </el-button>
      </div>
      <div class="table-wrap">
        <el-table
          :data="tableRows"
          border
          row-key="rowKey"
          class="product-list-table"
          empty-text="暂无数据"
          :span-method="tableSpanMethod"
        >
          <el-table-column
            label="编号"
            width="90"
          >
            <template slot-scope="scope">
              <div class="id-cell">
                {{ scope.row._product.id }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label="产品名称"
            width="240"
          >
            <template slot-scope="scope">
              <div class="product-name">
                {{ scope.row._product.name }}
              </div>
              <div
                v-if="scope.row._product.meta"
                class="product-meta"
              >
                {{ scope.row._product.meta }}
              </div>
            </template>
          </el-table-column>

          <el-table-column label="软件著作" width="210">
            <template slot-scope="scope">
                <img v-for="(img, index) in scope.row.copyright_imgs"
                    :key="(typeof img === 'string' ? img : ((img && (img.url || img.remote_url || img.id)) || index)) + '-copyright-' + index"
                    class="pm-copyright-thumb"
                    :src="typeof img === 'string' ? img : ((img && (img.url || img.remote_url)) || '')"
                    @click="handleSoftPreview(img)"
                    alt="软件著作"
                />
            </template>
          </el-table-column>

          <el-table-column label="快应用上架厂商" min-width="180">
              <template slot-scope="scope">
                  <div v-if="scope.row.quickAppVendors.length" class="vendor-list">
                      <el-tag
                          v-for="vendor in scope.row.quickAppVendors"
                          :key="scope.row._rowKey + '-' + vendor"
                          size="mini"
                      >
                          {{ vendor }}
                      </el-tag>
                  </div>
                  <span v-else class="muted">--</span>
              </template>
          </el-table-column>

          <el-table-column
            label="平台"
            width="120"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.label !== '--'"
                class="platform-tag"
              >
                {{ scope.row.label }}
            </span>
              <span
                v-else
                class="muted"
              >
                --
              </span>
            </template>
          </el-table-column>

          <el-table-column
            label="包名"
            width="240"
          >
            <template slot-scope="scope">
              <div class="mono">
                {{ scope.row.packageName || '--' }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label="DP Schema"
            width="380"
          >
            <template slot-scope="scope">
              <div
                v-if="scope.row.dpList.length > 0"
                class="schema-list"
              >
                <template v-for="(dp, dpIndex) in scope.row.dpList">
                  <el-popover
                    :key="scope.row.rowKey + '-dp-' + dpIndex"
                    placement="top-start"
                    trigger="hover"
                    width="360"
                  >
                    <div class="demo-popover-title">
                      DP Demo
                    </div>
                    <div class="demo-popover-body">
                      {{ dp.demo || '暂无 DP Demo' }}
                    </div>
                    <el-button
                      slot="reference"
                      type="text"
                      class="schema-link"
                    >
                      {{ dp.schema || '未命名 DP' }}
                    </el-button>
                  </el-popover>
                  <span
                    v-if="dpIndex < scope.row.dpList.length - 1"
                    :key="scope.row.rowKey + '-sep-' + dpIndex"
                    class="schema-separator"
                  >
                    ，
                  </span>
                </template>
              </div>
              <span
                v-else
                class="muted"
              >
                --
              </span>
            </template>
          </el-table-column>

          <el-table-column
            label="是否IAA产品"
            width="120"
          >
            <template slot-scope="scope">
              <div class="mono">
                <el-tag
                  class="tag"
                  type="info"
                  :type="scope.row.is_iaa === 1 ? 'success' : 'info'"
                  v-if="[0, 1].includes(scope.row.is_iaa)"
                >
                  {{ scope.row.is_iaa === 1 ? '是' : '否'}}
                </el-tag>
                <span v-else>--</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label="链接来源"
            width="120"
          >
            <template slot-scope="scope">
              <div class="mono">
                <el-tag
                  class="tag"
                  type="info"
                >
                  {{ scope.row.created_source || '--'}}
                </el-tag>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label="创建主体"
            width="220"
          >
            <template slot-scope="scope">
              <div class="creator-cell">
                <span class="creator-text">
                  {{ scope.row._product.creatorInfo.text }}
                </span>
                <button
                  type="button"
                  class="creator-action"
                  @click.stop="handleTransferCreator(scope.row._product.raw)"
                >
                  转归属
                </button>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label="状态"
            width="140"
          >
            <template slot-scope="scope">
              <span
                :class="[
                  'status-chip',
                  scope.row._product.statusInfo.className,
                ]"
              >
                {{ scope.row._product.statusInfo.label }}
              </span>
              <div
                v-if="
                  scope.row._product.statusInfo.key === 'reject' &&
                    scope.row._product.rejectReason
                "
                class="reason-text"
              >
                驳回理由：{{ scope.row._product.rejectReason }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label="备注"
            width="200"
          >
            <template slot-scope="scope">
              <div class="remark-cell">
                <span class="remark-text">
                  {{ scope.row.remark }}
                </span>
                <el-button
                  type="text"
                  class="link-action"
                  id="remark_edit"
                  @click.stop="openRemarkEdit(scope.row._product.raw)"
                >
                  修改备注
                </el-button>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="220"
            fixed="right"
          >
            <template slot-scope="scope">
              <div class="action-list">
                <el-button
                  type="text"
                  class="link-action"
                  @click="openEdit(scope.row._product.raw)"
                >
                  编辑
                </el-button>
                <el-button
                  v-if="scope.row._product.canDisable"
                  type="text"
                  class="link-action danger"
                  @click="handleDisable(scope.row._product.raw)"
                >
                  失效
                </el-button>
                <el-button
                  v-if="scope.row._product.canEnable"
                  type="text"
                  class="link-action"
                  style="color: #67c23c"
                  @click="handleEnable(scope.row._product.raw)"
                >
                  有效
                </el-button>
                <el-button
                  type="text"
                  class="link-action"
                  @click="openLog(scope.row._product.raw)"
                >
                  操作日志
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </section>

    <div class="pager-wrap">
      <el-pagination
        :current-page="query.form.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="query.form.page_size"
        layout="total, sizes, prev, pager, next"
        :total="table.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageChange"
      />
    </div>

    <el-drawer
      :visible.sync="drawer.visible"
      :title="drawer.title"
      size="1280px"
      direction="rtl"
      custom-class="product-edit-drawer"
      :wrapper-closable="false"
      @close="handleDrawerClose"
    >
      <create-form
        v-if="drawer.visible"
        :is-edit="edit.isEdit"
        :product="edit.product"
        @cancel="handleDrawerCancel"
        @success="handleDrawerSuccess"
      />
    </el-drawer>

    <el-dialog
      title="操作日志"
      :visible.sync="log.visible"
      width="1080px"
      custom-class="product-log-dialog"
      @close="handleLogClose"
    >
      <el-table
        v-loading="log.loading"
        :data="log.list"
        border
      >
        <el-table-column
          label="操作时间"
          prop="_time"
          width="180"
        />
        <el-table-column
          label="操作人"
          prop="_operator"
          width="180"
        />
        <el-table-column
          label="操作类型"
          prop="_type"
          width="140"
        />
        <el-table-column
          label="操作内容"
        >
          <template slot-scope="scope">
            <div class="log-content">
              {{ scope.row._content }}
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="log-pager">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="log.page"
          :page-size="log.pageSize"
          :total="log.total"
          @current-change="handleLogPageChange"
        />
      </div>
    </el-dialog>

    <el-dialog
      title="创建主体转归属"
      :visible.sync="transfer.visible"
      width="680px"
      custom-class="product-transfer-dialog"
      @close="handleTransferClose"
    >
      <div class="transfer-owner-current">
        <div>
          当前创建主体：
          <strong>{{ (transfer.currentOwner || {}).text || '--' }}</strong>
        </div>
        <div>
          目标创建主体：
          <strong>{{ (transfer.targetOwner || {}).text || '—' }}</strong>
        </div>
      </div>

      <div class="transfer-owner-mode">
        <label
          :class="[
            'transfer-owner-option',
            {
              'is-active': transfer.targetType === 'crm',
              'is-disabled': isTransferOptionDisabled('crm'),
            },
          ]"
        >
          <el-radio
            v-model="transfer.targetType"
            label="crm"
            :disabled="isTransferOptionDisabled('crm')"
            @change="handleTransferTargetTypeChange"
          >
            CRM平台
          </el-radio>
          <small>代理或子代理创建的产品，可直接转为当前 CRM 操作人。</small>
        </label>

        <label
          :class="[
            'transfer-owner-option',
            {
              'is-active': transfer.targetType === 'agent',
              'is-disabled': isTransferOptionDisabled('agent'),
            },
          ]"
        >
          <el-radio
            v-model="transfer.targetType"
            label="agent"
            :disabled="isTransferOptionDisabled('agent')"
            @change="handleTransferTargetTypeChange"
          >
            代理商/子代理
          </el-radio>
          <small>CRM 平台归属转代理商/子代理时，需要输入代理商/子代理 ID 查询。</small>
        </label>
      </div>

      <div
        v-if="transfer.targetType && transfer.targetType !== 'crm'"
        class="transfer-owner-search"
      >
        <el-select
          v-model="transfer.targetId"
          filterable
          remote
          reserve-keyword
          clearable
          :loading="transfer.querying"
          :placeholder="getTransferIdPlaceholder()"
          @clear="handleTransferTargetSelect('')"
          @change="handleTransferTargetSelect"
          :remote-method="handleTransferTargetSearch"
          style="width: 100%"
        >
          <el-option
            v-for="item in transfer.targetOptions"
            :key="`${item.type}-${item.id}`"
            :label="`${item.id} - ${item.name}`"
            :value="item.id"
          />
        </el-select>
      </div>

      <!-- <div
        :class="[
          'transfer-owner-result',
          transfer.resultState ? `is-${transfer.resultState}` : '',
        ]"
      >
        {{ transfer.resultText || '请选择目标创建主体。' }}
      </div> -->

      <div class="transfer-owner-tip">
        确认转归属后，创建主体会立即更新，并记录操作日志；该操作仅调整创建主体归属，不修改产品审核状态。
      </div>

      <span slot="footer">
        <el-button @click="transfer.visible = false">
          取消
        </el-button>
        <el-button
          type="primary"
          :loading="transfer.submitting"
          :disabled="!transfer.targetOwner"
          @click="confirmTransferCreator"
        >
          确认转归属
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="修改备注"
      :visible.sync="remarkDialog.visible"
      width="560px"
      custom-class="product-remark-dialog"
      @close="handleRemarkClose"
    >
      <div class="remark-dialog-meta">
        产品：
        <strong>{{ remarkDialog.productName || '--' }}</strong>
      </div>

      <el-form @submit.native.prevent>
        <el-form-item
          label="备注"
          label-width="60px"
          class="remark-form-item"
        >
          <el-input
            v-model.trim="remarkDialog.form.remark"
            type="textarea"
            :rows="5"
            maxlength="200"
            placeholder="请输入备注，留空则清空备注"
          />
        </el-form-item>
      </el-form>

      <!-- <div class="remark-dialog-tip">
        修改后将立即生效，并记录到操作日志中。
      </div> -->

      <span slot="footer">
        <el-button @click="remarkDialog.visible = false">
          取消
        </el-button>
        <el-button
          type="primary"
          :loading="remarkDialog.loading"
          @click="submitRemarkEdit"
        >
          确认
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="软件著作预览"
        :visible.sync="softPreview.visible"
        append-to-body
        width="720px"
        custom-class="pm-image-preview-dialog"
        @close="handleSoftPreviewClose"
    >
        <div class="pm-image-preview-body">
            <img v-if="softPreview.url" :src="softPreview.url" alt="软件著作预览" class="pm-image-preview-img" style="max-width: 100%; max-height: 100%;">
            <div v-else class="pm-empty">暂无可预览图片</div>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import Request from '@/core/QuRequest';
import CreateForm from './components/createForm.vue';

const req = new Request();

const STATUS_OPTIONS = [
  { label: '有效', value: 0 },
  { label: '无效', value: 1 },
];

const AUDIT_STATUS_OPTIONS = [
  { label: '待审核', value: 0 },
  { label: '通过', value: 1 },
  { label: '驳回', value: 2 },
];

const STATUS_META = {
  pending: { key: 'pending', label: '待审核', className: 'pending' },
  pass: { key: 'pass', label: '有效', className: 'pass' },
  reject: { key: 'reject', label: '驳回', className: 'reject' },
  invalid: { key: 'invalid', label: '无效', className: 'invalid' },
  unknown: { key: 'unknown', label: '--', className: 'invalid' },
};

const CUSTOMER_TYPE_MAP = {
  0: '普通',
  1: 'KA',
  2: '其他',
};

const QUICK_APP_VENDOR_LABEL_MAP = {
    huawei: '华为',
    vivo: 'vivo',
    oppo: 'OPPO',
    xiaomi: '小米',
    honor: '荣耀'
};


const PLATFORM_FIELD_MAP = {
  android: {
    packageKeys: [
      'android_package_name',
    ],
    linkKeys: [
      'android_download_url',
      'android_store_url',
      'android_link',
      'android_url',
      'android_download_link',
    ],
    dpJsonKeys: [
      'android_dp_list',
      'android_dp_info',
      'android_deeplink_list',
      'android_schema_list',
    ],
    dpTextKeys: ['android_deeplink', 'android_dp_schema', 'android_schema'],
  },
  ios: {
    packageKeys: ['ios_package_name'],
    linkKeys: [
      'ios_download_url',
      'ios_store_url',
      'ios_link',
      'ios_url',
      'ios_download_link',
    ],
    dpJsonKeys: [
      'ios_dp_list',
      'ios_dp_info',
      'ios_deeplink_list',
      'ios_schema_list',
    ],
    dpTextKeys: ['ios_deeplink', 'ios_dp_schema', 'ios_schema'],
  },
};

function hasValue(value) {
  if (value === 0) return true;
  if (value === false) return true;
  if (value === undefined || value === null) return false;
  if (typeof value === 'string') return value.trim() !== '';
  return true;
}

function safeTrim(value) {
  if (typeof value === 'string') return value.trim();
  if (value === undefined || value === null) return '';
  return String(value).trim();
}

function tryParseJson(value) {
  if (typeof value !== 'string') return value;
  try {
    return JSON.parse(value);
  } catch (err) {
    return null;
  }
}

function splitSchemas(value) {
  return safeTrim(value)
    .split(/[\n\r,，]+/)
    .map((item) => item.trim())
    .filter(Boolean);
}

function escapeHtml(value) {
  return safeTrim(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function buildWarningMessageHtml(title, warningText) {
  const safeTitle = escapeHtml(title);
  const safeWarning = escapeHtml(warningText).replace(/\r?\n/g, '<br>');

  return `${safeTitle}<br>${safeWarning}`;
}

function createEmptyDp() {
  return {
    schema: '',
    demo: '',
  };
}

function createEmptyDevice() {
  return {
    packageName: '',
    link: '',
    dpList: [createEmptyDp()],
  };
}

function createEmptyForm() {
  return {
    id: '',
    name: '',
    android: createEmptyDevice(),
    ios: createEmptyDevice(),
  };
}

function createTransferState() {
  return {
    visible: false,
    querying: false,
    submitting: false,
    row: null,
    currentOwner: null,
    targetType: '',
    targetId: '',
    targetName: '',
    targetOwner: null,
    targetOptions: [],
    resultText: '',
    resultState: 'info',
  };
}

function createRemarkDialogState() {
  return {
    visible: false,
    loading: false,
    row: null,
    productName: '',
    form: {
      id: '',
      remark: '',
    },
  };
}

function clonePlainData(value) {
  try {
    return JSON.parse(JSON.stringify(value));
  } catch (err) {
    if (Array.isArray(value)) return value.slice();
    if (value && typeof value === 'object') return { ...value };
    return value;
  }
}

function toArray (value) {
    if (Array.isArray(value)) {
        return value.filter(item => item !== undefined && item !== null && item !== '');
    }

    if (value === undefined || value === null || value === '') {
        return [];
    }

    return [value];
}

function formatVendorLabel (vendor) {
    const key = `${vendor || ''}`.toLowerCase();
    return QUICK_APP_VENDOR_LABEL_MAP[key] || vendor || '--';
}

export default {
  name: 'OperationProductManagePage',
  components: {
    CreateForm,
  },
  data() {
    return {
      StatusOptions: STATUS_OPTIONS,
      AuditStatusOptions: AUDIT_STATUS_OPTIONS,
      query: {
        form: {
          page: 1,
          page_size: 10,
          keyword: '',
          status: '',
          audit_status: '',
        },
      },
      queryExpanded: true,
      table: {
        list: [],
        total: 0,
        loading: false,
      },
      edit: {
        loading: false,
        type: 'Add',
        raw: null,
        form: createEmptyForm(),
        isEdit: false,
        product: {},
      },
      drawer: {
        visible: false,
        title: '添加产品',
      },
      log: {
        visible: false,
        loading: false,
        row: null,
        list: [],
        total: 0,
        page: 1,
        pageSize: 10,
      },
      userInfo: {},
      transfer: createTransferState(),
      remarkDialog: createRemarkDialogState(),
      softPreview: {
        visible: false,
        url: ''
      },
    };
  },
  computed: {
    queryKeywordSpan() {
      return 8;
    },
    queryStatusSpan() {
      return 5;
    },
    queryAuditStatusSpan() {
      return 5;
    },
    queryActionSpan() {
      return 6;
    },
    normalizedList() {
      return (this.table.list || []).map((row, index) =>
        this.normalizeProductRow(row, index),
      );
    },
    tableRows() {
      const _rows = this.normalizedList.reduce((rows, product) => {
        const rowSpan = product.platforms.length || 1;
        product.platforms.forEach((platform, index) => {
          rows.push({
            ...platform,
            rowKey: `${product.key}-${platform.key}-${index}`,
            _product: product,
            _groupKey: product.key,
            _rowspan: rowSpan,
            _isFirstPlatformRow: index === 0,
          });
        });
        return rows;
      }, []);
      return _rows
    },
  },
  created() {
    this.getProductList();
    this.getUserInfo();
  },
  methods: {
    async getUserInfo() {
      try {
        const res = await req.send(req.Apis.sales.user.userInfo);
        if (res.code === 200) {
          this.userInfo = res.data || {};
        }
      } catch (err) {
        this.userInfo = {};
      }
    },

    async getProductList() {
      try {
        this.table.loading = true;
        const res = await req
          .send(req.Apis.sales.product.productRead, this.buildListParams())
          .fin(() => {
            this.table.loading = false;
          });
        const data = res.data || {};
        const list = data.data || data.list || [];
        this.table.list = Array.isArray(list) ? list : [];
        this.table.total = Number(data.total || this.table.list.length || 0);
      } catch (err) {
        this.$message.error(`获取产品列表失败：${err.message || '未知错误'}`);
      }
    },

    handleSoftPreview: function (file) {
      var previewUrl = '';

      if (typeof file === 'string') {
          previewUrl = file;
      }
      else {
          previewUrl = (file && (file.url || file.remote_url || file.thumbUrl)) || '';
      }

      if (!previewUrl && file && file.response) {
          previewUrl = file.response.remote_url || '';
      }

      if (!previewUrl) {
          this.$message.error('暂无可预览图片');
          return;
      }

      this.softPreview.url = previewUrl;
      this.softPreview.visible = true;
  },
  handleSoftPreviewClose: function () {
      this.softPreview.visible = false;
      this.softPreview.url = '';
  },

    buildListParams() {
      const params = {
        page: Number(this.query.form.page) || 1,
        page_size: Number(this.query.form.page_size) || 10,
      };

      if (hasValue(this.query.form.keyword)) {
        params.keyword = this.query.form.keyword;
      }

      if (hasValue(this.query.form.audit_status)) {
        params.audit_status = this.query.form.audit_status;
      }

      if (hasValue(this.query.form.status)) {
        params.status = this.query.form.status;
      }

      return params;
    },

    handleFilter() {
      this.query.form.page = 1;
      this.getProductList();
    },

    handleReset() {
      this.query.form.keyword = '';
      this.query.form.audit_status = '';
      this.query.form.status = '';
      this.query.form.page = 1;
      this.queryExpanded = false;
      // this.getProductList();
    },

    toggleQueryExpand() {
      this.queryExpanded = !this.queryExpanded;
    },

    handlePageSizeChange(pageSize) {
      this.query.form.page_size = Number(pageSize) || 10;
      this.query.form.page = 1;
      this.getProductList();
    },

    handlePageChange(page) {
      this.query.form.page = Number(page) || 1;
      this.getProductList();
    },

    handleAdd() {
      this.openEdit();
    },

    openRemarkEdit(row = {}) {
      const id = this.getRowId(row);
      if (!id) {
        this.$message.error('未找到产品编号');
        return;
      }

      this.remarkDialog = {
        ...createRemarkDialogState(),
        visible: true,
        row,
        productName: this.pickValue(row, ['name', 'product_name']) || '--',
        form: {
          id,
          remark: safeTrim(this.pickValue(row, ['remark'])),
        },
      };
    },

    handleRemarkClose() {
      this.remarkDialog = createRemarkDialogState();
    },
    
    async submitRemarkEdit() {
      const row = this.remarkDialog.row || {};
      const id = this.getRowId(row);
      if (!id) {
        this.$message.error('未找到产品编号');
        return;
      }

      try {
        this.remarkDialog.loading = true;
        const res = await req
          .send(
            req.Apis.sales.product.productRemarkEdit,
            {
              product_id: this.getRowId(row) || '--',
              remark: this.remarkDialog.form.remark
            },
          )
          .fin(() => {
            this.remarkDialog.loading = false;
          });

        if (res.code !== 200) {
          this.$message.error(res.message || '备注修改失败');
          return;
        }

        this.$message.success('备注修改成功');
        this.remarkDialog.visible = false;
        this.getProductList();
      } catch (err) {
        this.$message.error(`备注修改失败：${err.message || '未知错误'}`);
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    tableSpanMethod({ row, columnIndex }) {
      const mergeColumns = [0, 1, 2, 3, 7, 8, 9, 10, 11, 12];
      if (!mergeColumns.includes(columnIndex)) {
        return [1, 1];
      }

      if (row._isFirstPlatformRow) {
        return [row._rowspan, 1];
      }

      return [0, 0];
    },

    normalizeProductRow(row = {}, index = 0) {
      const id = this.getRowId(row) || '--';
      const name = this.pickValue(row, ['name', 'product_name']) || '--';
      const meta = this.buildProductMeta(row);
      const creatorInfo = this.buildCreatorInfo(row);
      const statusInfo = this.getStatusMeta(row);
      const rejectReason = this.getRejectReason(row);
      const platforms = [
        this.buildPlatformInfo(row, 'android', 'Android'),
        this.buildPlatformInfo(row, 'ios', 'iOS'),
      ].filter(Boolean);

      if (platforms.length === 0) {
        platforms.push({
          key: `empty-${id || index}`,
          rowKey: `empty-${id || index}`,
          label: '--',
          packageName: '--',
          is_iaa: row.is_iaa,
          created_source: row.created_source || '--',
          remark: row.remark || '--',
          link: '',
          dpList: [],
          copyright_imgs: [],
          quickAppVendors: []
        });
      }

      return {
        key: id || index,
        id,
        name,
        meta,
        is_iaa: row.is_iaa,
        created_source: row.created_source || '--',
        remark: row.remark || '--',
        creatorText: creatorInfo.text,
        creatorInfo,
        statusInfo,
        rejectReason,
        platforms,
        canDisable: row.product_status == '0' && row.audit_status !=='0',
        canEnable: row.product_status == '1' && row.audit_status !=='0',
        copyright_imgs: row.copyright_imgs,
        quickAppVendors: toArray((row.app_delivery_info || {}).quick_app_vendor).map(formatVendorLabel),
        raw: row,
      };
    },

    buildPlatformInfo(row, prefix, label) {
      const config = PLATFORM_FIELD_MAP[prefix];
      const productId = this.getRowId(row) || '--';
      const packageName = this.pickValue(row, config.packageKeys);
      const appDeliveryInfo = row.app_delivery_info || {};
      const platformInfo = appDeliveryInfo[prefix] || {};
      const link = this.pickValue(platformInfo, [
        'download_url',
        'universal_link',
      ]) || this.pickValue(row, config.linkKeys);
      const dpList = this.parseDpList(row, prefix);

      if (!packageName && !link && dpList.length === 0) {
        return null;
      }

      return {
        key: prefix,
        rowKey: `${productId}-${prefix}`,
        label,
        packageName: packageName || '--',
        is_iaa: row.is_iaa,
        created_source: row.created_source || '--',
        remark: row.remark || '--',
        link: link || '',
        dpList,
        copyright_imgs: row.copyright_imgs,
        quickAppVendors: toArray((row.app_delivery_info || {}).quick_app_vendor).map(formatVendorLabel)
      };
    },

    parseDpList(row, prefix) {
      const config = PLATFORM_FIELD_MAP[prefix];
      const appDeliveryInfo = row.app_delivery_info || {};
      const platformInfo = appDeliveryInfo[prefix] || {};
      const deliveryDpList = platformInfo.deeplinks;

      if (Array.isArray(deliveryDpList)) {
        const list = deliveryDpList
          .map((item) => this.normalizeDpItem(item))
          .filter(Boolean);
        if (list.length > 0) {
          return list;
        }
      }

      for (let i = 0; i < config.dpJsonKeys.length; i += 1) {
        const key = config.dpJsonKeys[i];
        const rawValue = row[key];
        if (!hasValue(rawValue)) continue;

        let parsed = rawValue;
        if (typeof rawValue === 'string') {
          parsed = tryParseJson(rawValue);
        }

        if (Array.isArray(parsed)) {
          const list = parsed
            .map((item) => this.normalizeDpItem(item))
            .filter(Boolean);
          if (list.length > 0) return list;
        }

        if (parsed && typeof parsed === 'object') {
          const list = Object.keys(parsed).map((schema) =>
            this.normalizeDpItem({
              schema,
              demo: parsed[schema],
            }),
          );
          const cleanedList = list.filter(Boolean);
          if (cleanedList.length > 0) return cleanedList;
        }
      }

      for (let i = 0; i < config.dpTextKeys.length; i += 1) {
        const key = config.dpTextKeys[i];
        const rawValue = row[key];
        if (!hasValue(rawValue)) continue;

        const parsed =
          typeof rawValue === 'string' ? tryParseJson(rawValue) : rawValue;
        if (Array.isArray(parsed)) {
          const list = parsed
            .map((item) => this.normalizeDpItem(item))
            .filter(Boolean);
          if (list.length > 0) return list;
        }

        const schemas = splitSchemas(rawValue);
        if (schemas.length > 0) {
          return schemas.map((schema) => ({
            schema,
            demo: schema,
          }));
        }
      }

      return [];
    },

    normalizeDpItem(item) {
      if (!hasValue(item)) return null;

      if (typeof item === 'string' || typeof item === 'number') {
        const schema = safeTrim(item);
        if (!schema) return null;
        return {
          schema,
          demo: schema,
        };
      }

      const schema = this.pickValue(item, [
        'schema',
        'dp_schema',
        'deeplink',
        'name',
        'key',
        'head',
      ]);
      const demo = this.pickValue(item, [
        'demo',
        'dp_demo',
        'example',
        'url',
        'link',
        'value',
        'content',
      ]);

      if (!schema && !demo) return null;

      return {
        schema: schema || demo,
        demo: demo || schema || '',
      };
    },

    buildCreatorInfo(row = {}) {
      const directText = this.pickValue(row, [
        'create_subject_text',
        'creator_text',
        'owner_text',
        'operator',
      ]);
      const creatorName = this.pickValue(row, [
        'create_subject_name',
        'creator_name',
        'owner_name',
        'source_name',
        'operator',
      ]);
      const creatorType = this.pickValue(row, [
        'creator_prefix',
        'create_subject_type',
        'creator_type',
        'owner_type',
        'create_source_text',
      ]);
      const creatorTypeLabel = this.normalizeCreatorTypeLabel(creatorType);

      if (directText) {
        return {
          text: directText,
          name: creatorName || directText,
          type: creatorType,
          typeLabel: creatorTypeLabel,
        };
      }

      if (creatorTypeLabel && creatorName) {
        return {
          text: `${creatorTypeLabel}：${creatorName}`,
          name: creatorName,
          type: creatorType,
          typeLabel: creatorTypeLabel,
        };
      }

      if (creatorName) {
        return {
          text: creatorName,
          name: creatorName,
          type: creatorType,
          typeLabel: creatorTypeLabel,
        };
      }

      return {
        text: '--',
        name: '',
        type: creatorType,
        typeLabel: creatorTypeLabel,
      };
    },

    normalizeCreatorTypeLabel(value) {
      const text = safeTrim(value);
      const creatorTypeMap = {
        crm: 'CRM平台',
        CRM: 'CRM平台',
        platform: 'CRM平台',
        agent: '代理',
        subAgent: '子代理',
        sub_agent: '子代理',
        child_agent: '子代理',
        0: 'CRM平台',
        1: '代理',
        2: '子代理',
      };

      if (!text) return '';
      return creatorTypeMap[text] || text;
    },

    buildProductMeta(row = {}) {
      const parts = [];
      const industry = this.pickValue(row, [
        'industry_path',
        'industry_name',
        'category_path',
        'category_name',
      ]);
      const series = this.pickValue(row, ['series_name', 'series']);
      const customerType = hasValue(row.customer_type)
        ? CUSTOMER_TYPE_MAP[safeTrim(row.customer_type)] || ''
        : '';

      if (industry) parts.push(industry);
      if (series) parts.push(series);
      if (customerType) parts.push(customerType);

      if (parts.length === 0) {
        const fallback = this.pickValue(row, [
          'product_company',
          'company',
          'remark',
        ]);
        if (fallback) parts.push(fallback);
      }

      return parts.join(' / ');
    },

    getRejectReason(row = {}) {
      return this.pickValue(row, [
        'audit_reason',
        'reject_reason',
        'review_reason',
        'reason',
        'comment',
      ]);
    },

    getStatusValue(row = {}) {
      return this.pickValue(row, [
        'audit_status',
        'review_status',
        'apply_status',
        'audit_result',
        'status',
        'state',
      ]);
    },

    getStatusMeta(row = {}) {
      // const auditStatus = safeTrim(row.audit_status);
      // const status = safeTrim(row.status);

      const showStatus = safeTrim(row.show_status);

      if (showStatus == '6') {
        return STATUS_META.pending;
      }

      if (showStatus === '8') {
        return STATUS_META.reject;
      }

      if (showStatus == '1' || showStatus == '7') {
        return STATUS_META.pass;
      }

      if (showStatus == '2') {
        return STATUS_META.invalid;
      }

      return STATUS_META.invalid;
    },

    getRowId(row = {}) {
      return this.pickValue(row, ['id', 'product_id']);
    },

    pickValue(source = {}, keys = []) {
      for (let i = 0; i < keys.length; i += 1) {
        const key = keys[i];
        if (
          Object.prototype.hasOwnProperty.call(source, key) &&
          hasValue(source[key])
        ) {
          return source[key];
        }
      }
      return '';
    },

    openEdit(row = null) {
      const normalizedRow = row || null;
      this.edit.type = normalizedRow ? 'Edit' : 'Add';
      this.edit.raw = normalizedRow;
      this.edit.form = this.makeEditForm(normalizedRow);
      this.edit.isEdit = Boolean(normalizedRow);
      this.edit.product = normalizedRow ? { ...normalizedRow } : {};
      this.drawer.title = normalizedRow ? '编辑产品' : '添加产品';
      this.drawer.visible = true;
    },

    makeEditForm(row = null) {
      if (!row) {
        return createEmptyForm();
      }

      const androidInfo = this.buildPlatformInfo(row, 'android', 'Android');
      const iosInfo = this.buildPlatformInfo(row, 'ios', 'iOS');

      return {
        id: this.getRowId(row),
        name: this.pickValue(row, ['name', 'product_name']),
        android: {
          packageName:
            (androidInfo || {}).packageName === '--'
              ? ''
              : (androidInfo || {}).packageName || '',
          link: (androidInfo || {}).link || '',
          dpList: this.cloneDpList((androidInfo || {}).dpList || []),
        },
        ios: {
          packageName:
            (iosInfo || {}).packageName === '--'
              ? ''
              : (iosInfo || {}).packageName || '',
          link: (iosInfo || {}).link || '',
          dpList: this.cloneDpList((iosInfo || {}).dpList || []),
        },
      };
    },

    cloneDpList(list = []) {
      const cleanedList = Array.isArray(list) ? list : [];
      if (cleanedList.length === 0) {
        return [createEmptyDp()];
      }

      return cleanedList.map((item) => ({
        schema: item.schema || '',
        demo: item.demo || '',
      }));
    },

    handleDrawerClose() {
      this.edit.loading = false;
      this.edit.raw = null;
      this.edit.form = createEmptyForm();
      this.edit.isEdit = false;
      this.edit.product = {};
    },

    handleDrawerCancel() {
      this.drawer.visible = false;
    },

    handleDrawerSuccess() {
      this.drawer.visible = false;
      this.getProductList();
    },

    // async handleDrawerSubmit(payload, form) {
    //   try {
    //     this.edit.loading = true;
    //     const api =
    //       this.edit.type === 'Add'
    //         ? req.Apis.sales.product.productAdd
    //         : req.Apis.sales.product.productEdit;
    //     const submitPayload = this.buildSubmitPayload(form);

    //     await req.send(api, submitPayload).fin(() => {
    //       this.edit.loading = false;
    //     });

    //     this.edit.form = form;
    //     this.drawer.visible = false;
    //     this.$message.success(
    //       this.edit.type === 'Add'
    //         ? '已添加并提交审核，状态为待审核'
    //         : '已保存并提交审核，状态已变为待审核',
    //     );
    //     this.getProductList();
    //   } catch (err) {
    //     this.$message.error(`保存失败：${err.message || '未知错误'}`);
    //   }
    // },

    buildSubmitPayload(form = createEmptyForm()) {
      const submitForm = form || createEmptyForm();
      const androidDevice = submitForm.android || {};
      const iosDevice = submitForm.ios || {};
      const androidDpList = this.getCleanDpList(androidDevice.dpList);
      const iosDpList = this.getCleanDpList(iosDevice.dpList);
      const submitPayload = {
        name: safeTrim(submitForm.name),
        product_name: safeTrim(submitForm.name),
        android_package_name: safeTrim(androidDevice.packageName),
        android_deeplink: androidDpList
          .map((item) => item.schema)
          .filter(Boolean)
          .join(','),
        ios_package_name: safeTrim(iosDevice.packageName),
        ios_deeplink: iosDpList
          .map((item) => item.schema)
          .filter(Boolean)
          .join(','),
      };

      if (hasValue(submitForm.id)) {
        submitPayload.id = submitForm.id;
      }

      this.appendCompatibilityPayload(submitPayload, 'android', {
        ...androidDevice,
        dpList: androidDpList,
      });
      this.appendCompatibilityPayload(submitPayload, 'ios', {
        ...iosDevice,
        dpList: iosDpList,
      });

      return submitPayload;
    },

    appendCompatibilityPayload(payload, prefix, device) {
      const raw = this.edit.raw || {};
      const config = PLATFORM_FIELD_MAP[prefix];
      const dpList = Array.isArray(device.dpList) ? device.dpList : [];
      const existingLinkKey = this.findExistingKey(raw, config.linkKeys);
      const existingDpKey = this.findExistingKey(raw, config.dpJsonKeys);

      if (existingLinkKey) {
        payload[existingLinkKey] = safeTrim(device.link);
      } else if (hasValue(device.link)) {
        payload[`${prefix}_download_url`] = safeTrim(device.link);
      }

      if (existingDpKey) {
        payload[existingDpKey] = JSON.stringify(dpList);
      } else if (dpList.length > 0) {
        payload[`${prefix}_dp_list`] = JSON.stringify(dpList);
      }
    },

    findExistingKey(source = {}, keys = []) {
      for (let i = 0; i < keys.length; i += 1) {
        if (Object.prototype.hasOwnProperty.call(source, keys[i])) {
          return keys[i];
        }
      }
      return '';
    },

    getCleanDpList(list = []) {
      return (Array.isArray(list) ? list : [])
        .map((item) => ({
          schema: safeTrim(item.schema),
          demo: safeTrim(item.demo),
        }))
        .filter((item) => item.schema || item.demo);
    },

    async handleDisable(row) {
      const id = this.getRowId(row);
      if (!id) return;

      try {
        await this.$confirm(
          `确认将产品【${this.pickValue(row, ['name', 'product_name']) ||
            id}】置为无效？`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        );

        const res = await req.send(req.Apis.sales.product.setStatus, {
          id,
          status: 1,
        });

        if(res.code === 200){
          if(res.data && res.data.package_duplicate_warning) {
            this.$message.warning({
              message: buildWarningMessageHtml('已将产品置为无效!', res.data.package_duplicate_warning),
              dangerouslyUseHTMLString: true,
              duration: 5000,
            });
          } else {
            this.$message.success('已将产品置为无效!');
          }
        }

        this.getProductList();
      } catch (err) {
        if (err === 'cancel' || err === 'close') return;
        this.$message.error(`操作失败：${err.message || '未知错误'}`);
      }
    },

    async handleEnable(row) {
      const id = this.getRowId(row);
      if (!id) return;

      try {
        await this.$confirm(
          `确认将产品【${this.pickValue(row, ['name', 'product_name']) ||
            id}】置为有效？`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        );

        const res = await req.send(req.Apis.sales.product.setStatus, {
          id,
          status: 0,
        });

        if(res.code === 200){
          if(res.data && res.data.package_duplicate_warning) {
            this.$message.warning({
              message: buildWarningMessageHtml('已将产品置为有效!', res.data.package_duplicate_warning),
              dangerouslyUseHTMLString: true,
              duration: 5000,
            });
          } else {
            this.$message.success('已将产品置为有效!');
          }
        }
        
        this.getProductList();
      } catch (err) {
        if (err === 'cancel' || err === 'close') return;
        this.$message.error(`操作失败：${err.message || '未知错误'}`);
      }
    },

    openLog(row) {
      this.log.row = row;
      this.log.page = 1;
      this.log.visible = true;
      this.getLogList();
    },

    async getLogList() {
      if (!this.log.row) return;

      try {
        this.log.loading = true;
        const res = await req
          .send(req.Apis.sales.product.productLog, {
            product_id: this.getRowId(this.log.row),
            page: this.log.page,
            page_size: this.log.pageSize,
          })
          .fin(() => {
            this.log.loading = false;
          });
        const data = res.data || {};
        const list = data.list || data.data || [];
        this.log.list = (Array.isArray(list) ? list : []).map((item) =>
          this.normalizeLogItem(item),
        );
        this.log.total = Number(data.total || this.log.list.length || 0);
      } catch (err) {
        this.$message.error(`获取日志失败：${err.message || '未知错误'}`);
      }
    },

    normalizeLogItem(item = {}) {
      return {
        ...item,
        _time: this.pickValue(item, ['operate_time']) || '--',
        _operator:
          this.pickValue(item, ['operator']) ||
          [
            this.pickValue(item, ['user_id']),
            this.pickValue(item, ['username']),
          ]
            .filter(Boolean)
            .join(' - ') ||
          this.pickValue(item, ['username']) ||
          '--',
        _type:
          this.pickValue(item, ['action']) || '--',
        _content: (this.pickValue(item, ['action']) === '新增') ? '' : (
          this.formatLogExt(item.ext) ||
          this.pickValue(item, ['content']) ||
          this.formatLogParams(item.params) ||
          '--'),
      };
    },

    formatLogExt(ext) {
      if (!hasValue(ext)) return '';

      const parsed = typeof ext === 'string' ? tryParseJson(ext) : ext;

      if (Array.isArray(parsed)) {
        return parsed
          .map((item) => this.stringifyLogExtValue(item))
          .filter(Boolean)
          .join('\n');
      }

      const KEY_MAP = {
        android_package_name: '安卓包名',
        ios_package_name: 'ios包名',
        app_delivery_info: '设备信息',
        category: '行业',
        copyright_imgs: '软著',
        status: '状态',
        operator: '操作人'
      }

      if (parsed && typeof parsed === 'object') {
        return Object.keys(parsed)
          .map((key) => {
            const value = this.stringifyLogExtValue(parsed[key]) || '--';
            return `${KEY_MAP[key] || key}: ${value}`;
          })
          .join('\n');
      }

      return safeTrim(ext);
    },

    stringifyLogExtValue(value) {
      if (!hasValue(value)) return '';
      if (typeof value === 'object') {
        return JSON.stringify(value);
      }
      return safeTrim(value);
    },

    formatLogParams(params) {
      if (!hasValue(params)) return '';

      if (typeof params === 'object') {
        const text = JSON.stringify(params);
        return text.length > 120 ? `${text.slice(0, 120)}...` : text;
      }

      const parsed = tryParseJson(params);
      if (parsed && typeof parsed === 'object') {
        const text = JSON.stringify(parsed);
        return text.length > 120 ? `${text.slice(0, 120)}...` : text;
      }

      const text = safeTrim(params);
      return text.length > 120 ? `${text.slice(0, 120)}...` : text;
    },

    handleLogPageChange(page) {
      this.log.page = Number(page) || 1;
      this.getLogList();
    },

    handleLogClose() {
      this.log.loading = false;
      this.log.row = null;
      this.log.list = [];
      this.log.total = 0;
      this.log.page = 1;
    },

    resolveCreatorTypeKey(row = {}) {
      const candidates = [
        this.pickValue(row, [
          'create_subject_type',
          'creator_type',
          'owner_type',
          'creator_prefix',
          'create_source_text',
        ]),
        this.pickValue(row, [
          'create_subject_text',
          'creator_text',
          'owner_text',
        ]),
      ];
      const typeMap = {
        crm: 'crm',
        CRM: 'crm',
        platform: 'crm',
        'CRM平台': 'crm',
        '0': 'crm',
        agent: 'agent',
        '代理': 'agent',
        '1': 'agent',
        subAgent: 'subAgent',
        subagent: 'subAgent',
        sub_agent: 'subAgent',
        child_agent: 'subAgent',
        '子代理': 'subAgent',
        '2': 'subAgent',
      };

      for (let i = 0; i < candidates.length; i += 1) {
        const text = safeTrim(candidates[i]);
        if (text && typeMap[text]) {
          return typeMap[text];
        }
      }

      return '';
    },

    getTransferTypeLabel(type) {
      const labelMap = {
        crm: 'CRM平台',
        agent: '代理',
        subAgent: '子代理',
      };

      return labelMap[type] || safeTrim(type);
    },

    formatTransferOwnerText(type, name) {
      const label = this.getTransferTypeLabel(type);
      const normalizedName = safeTrim(name);

      if (label && normalizedName) {
        return `${label}：${normalizedName}`;
      }

      return normalizedName || label || '--';
    },

    resetTransferState() {
      this.transfer = createTransferState();
    },

    handleTransferClose() {
      this.resetTransferState();
    },

    getCurrentCrmOwner() {
      const name =
        this.pickValue(this.userInfo, [
          'username',
          'name',
          'real_name',
          'nickname',
        ]) || '当前CRM操作人';
      const id = safeTrim(
        this.pickValue(this.userInfo, ['id', 'user_id', 'uid']),
      );

      return {
        id,
        name,
        type: 'crm',
        text: this.formatTransferOwnerText('crm', name),
      };
    },

    isTransferOptionDisabled(type) {
      const currentType = ((this.transfer || {}).currentOwner || {}).typeKey;

      if (currentType === 'crm') {
        return type === 'crm';
      }

      if (currentType === 'agent' || currentType === 'subAgent') {
        return type !== 'crm';
      }

      return false;
    },
    getTransferIdPlaceholder() {
      return '请输入代理商/子代理 ID'
    },

    setTransferResult(message, state = 'info') {
      this.transfer.resultText = message;
      this.transfer.resultState = state;
    },

    handleTransferTargetTypeChange(type) {
      this.transfer.targetType = type;
      this.transfer.targetId = '';
      this.transfer.targetName = '';
      this.transfer.targetOwner = null;
      this.transfer.targetOptions = [];

      if (type === 'crm') {
        const crmOwner = this.getCurrentCrmOwner();
        this.transfer.targetOwner = crmOwner;
        this.setTransferResult(
          `确认后将创建主体转为 ${crmOwner.text}。`,
          'success',
        );
        return;
      }

      this.setTransferResult(
        `请输入${this.getTransferTypeLabel(type)}ID和名称后点击查询。`,
        'info',
      );
    },

    async handleTransferTargetSearch(keyword = '') {
      const type = this.transfer.targetType;
      const normalizedKeyword = safeTrim(keyword);

      if (!type || type === 'crm') {
        this.transfer.targetOptions = [];
        return;
      }

      if (!normalizedKeyword) {
        this.transfer.targetOptions = [];
        this.transfer.targetOwner = null;
        this.transfer.targetName = '';
        return;
      }

      try {
        this.transfer.querying = true;
        const list = await this.requestTransferTargetList(
          type,
          normalizedKeyword,
        );
        this.transfer.targetOptions = (Array.isArray(list) ? list : [])
          .map((item) => this.normalizeTransferTargetItem(item, type))
          .filter(Boolean);
      } catch (err) {
        this.transfer.targetOptions = [];
      } finally {
        this.transfer.querying = false;
      }
    },

    handleTransferTargetSelect(value) {
      const targetId = safeTrim(value);
      const match = (this.transfer.targetOptions || []).find(
        (item) => item.id === targetId,
      );

      this.transfer.targetId = targetId;
      this.transfer.targetOwner = match || null;
      this.transfer.targetName = match ? match.name : '';

      if (match) {
        this.setTransferResult(
          `已找到${this.getTransferTypeLabel(match.type)}：${match.name}（${match.id}）。`,
          'success',
        );
        return;
      }

      this.setTransferResult('请选择目标创建主体。', 'info');
    },

    async requestTransferTargetList(type, targetId) {
      const keyword = safeTrim(targetId);
      if (!keyword) return [];

      const res = await req.send(req.Apis.sales.product.queryAdvUser, {
        adv_user_id: keyword,
      });

      if(res.code === 200) {
        const data = [res.data];
        if (Array.isArray(data)) return data;
      } 

      return [];
    },

    normalizeTransferTargetItem(item = {}, type = '') {
      const idKeys = ['adv_user_id'];
      const nameKeys = [ 'username' ];
      const id = safeTrim(this.pickValue(item, idKeys));
      const name = safeTrim(this.pickValue(item, nameKeys));

      if (!id || !name) {
        return null;
      }

      return {
        id,
        name,
        type,
        text: this.formatTransferOwnerText(type, name),
      };
    },

    findTransferTargetMatch(list = [], type = '', targetId = '', targetName = '') {
      const normalizedId = safeTrim(targetId);
      const normalizedName = safeTrim(targetName);

      return (Array.isArray(list) ? list : [])
        .map((item) => this.normalizeTransferTargetItem(item, type))
        .filter(Boolean)
        .find(
          (item) => item.id === normalizedId && item.name === normalizedName,
        );
    },

    applyTransferCreatorPreview(row = {}, targetOwner = {}) {
      const creatorText =
        targetOwner.text ||
        this.formatTransferOwnerText(targetOwner.type, targetOwner.name);
      const creatorName = safeTrim(targetOwner.name);
      const creatorId = safeTrim(targetOwner.id);
      const creatorType = targetOwner.type || '';

      [
        ['create_subject_text', creatorText],
        ['create_subject_name', creatorName],
        ['create_subject_type', creatorType],
        ['create_subject_id', creatorId],
        ['creator_text', creatorText],
        ['creator_name', creatorName],
        ['creator_type', creatorType],
        ['creator_id', creatorId],
        ['owner_text', creatorText],
        ['owner_name', creatorName],
        ['owner_type', creatorType],
        ['owner_id', creatorId],
        ['source_name', creatorName],
        ['creator_prefix', creatorType],
        ['create_source_text', creatorType],
      ].forEach(([key, value]) => {
        this.$set(row, key, value);
      });

      this.table.list = [...this.table.list];
    },

    async confirmTransferCreator() {
      if (!this.transfer.row || !this.transfer.targetOwner) {
        return;
      }

      try {
        this.transfer.submitting = true;
        // 先按原型逻辑更新列表交互；后端接口未在当前仓库中找到明确封装。

        const params = {
          id: this.transfer.row.product_id,
          created_source: this.transfer.targetType === 'crm' ? 'crm' : 'adv',
          adv_user_id: this.transfer.targetId
        }

        if(params.created_source === 'crm') {
          delete params.adv_user_id
        }

        const res = await req.send(req.Apis.sales.product.changeOperator, params);

        if(res.code === 200) {
          this.$message.success(
            `创建主体已更新为 ${this.transfer.targetOwner.text}`,
          );
          this.getProductList();
        } 
        this.transfer.visible = false;
      } catch (err) {
        // this.$message.error(`转归属失败：${err.message || '未知错误'}`);
      } finally {
        this.transfer.submitting = false;
      }
    },

    handleTransferCreator(row = {}) {
      const creatorInfo = this.buildCreatorInfo(row);
      const currentType = this.resolveCreatorTypeKey(row);

      this.resetTransferState();
      this.transfer.visible = true;
      this.transfer.row = row;
      this.transfer.currentOwner = {
        ...creatorInfo,
        typeKey: currentType,
      };

      if (currentType === 'crm') {
        this.setTransferResult(
          '当前为 CRM 平台归属，请选择转为代理商或子代理，并输入 ID、名称查询。',
          'info',
        );
        return;
      }

      const crmOwner = this.getCurrentCrmOwner();
      this.transfer.targetType = 'crm';
      this.transfer.targetOwner = crmOwner;
      this.setTransferResult(
        `${creatorInfo.text || '--'} 可直接转为 ${crmOwner.text}。`,
        'success',
      );
    },
  },
};
</script>

<style lang="less" scoped>

.table-header-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-bottom: 10px;
  }

.pm-image-preview-dialog .el-dialog__body {
    padding-top: 12px;
}

.pm-copyright-thumb {
    width: 100px;
    height: 100px;
    margin: 0 8px 8px 0;
    border-radius: 4px;
    cursor: pointer;
    object-fit: cover;
    box-shadow: 0 2px 8px rgba(30, 42, 70, .12);
}

.product-page {
  min-width: 0;
}

.search {
  margin-bottom: 8px;
}

.query-form {
  width: 100%;
}

.query-item {
  margin-bottom: 12px;
}

.query-item--actions {
  display: flex;
  align-items: flex-start;
}

.query-buttons {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.back-btn {
  padding: 0;
  font-weight: 700;
}

.query-toggle {
  padding: 0;
}

/deep/ .query-form .el-form-item {
  display: block;
  width: 100%;
  margin-right: 0;
  margin-bottom: 0;
}

/deep/ .query-form .el-form-item__content {
  width: 100%;
}

/deep/ .query-buttons .el-button + .el-button {
  margin-left: 0;
}


.table-card {
  background: #fff;
  border: 1px solid #e6ebf2;
}

.table-wrap {
  // overflow-x: auto;
}

.product-list-table {
  // min-width: 1260px;
}

/deep/ .product-list-table .el-table__header th {
  background: #fbfcff;
  color: #8b93a3;
  font-size: 14px;
  font-weight: 800;
}

/deep/ .product-list-table .el-table__body td {
  padding: 14px 0;
  vertical-align: middle;
}

/deep/ .product-list-table .cell {
  line-height: 1.55;
}

/deep/ .product-list-table .el-table__body tr:hover > td {
  background: #fcfdff;
}

.id-cell {
  color: #626b7a;
  font-weight: 700;
  font-family: Arial, sans-serif;
}

.product-name {
  color: #2e3542;
  font-size: 15px;
  font-weight: 800;
  margin-bottom: 6px;
  word-break: break-word;
}

.product-meta {
  color: #7b8495;
  line-height: 1.6;
  word-break: break-word;
}

.platform-tag {
  color: #3f7cff;
  border-color: #cfe0ff;
  background: #f6f9ff;
  font-weight: 800;
  font-family: Arial, sans-serif;
  padding: 8px;
}

.mono {
  color: #3e4654;
  font-family: Arial, sans-serif;
  overflow-wrap: anywhere;
}

.muted {
  color: #9ba3b1;
}

.creator-cell {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px;
  line-height: 1.6;
}

.creator-text {
  color: #2f3747;
  font-weight: 700;
  word-break: break-word;
}

.creator-action {
  height: 24px;
  padding: 0 8px;
  border: 1px solid #cfe0ff;
  border-radius: 4px;
  background: #f6f9ff;
  color: #3f7cff;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
  white-space: nowrap;
}

.creator-action:hover {
  background: #e7f0ff;
}

.schema-list {
  color: #3f7cff;
  line-height: 1.8;
  word-break: break-word;
}

.schema-link {
  color: #3f7cff;
  font-weight: 800;
  line-height: inherit;
}

.schema-separator {
  color: #7b8495;
}

.demo-popover-title {
  font-weight: 800;
  margin-bottom: 8px;
}

.demo-popover-body {
  color: #3b4351;
  line-height: 1.7;
  overflow-wrap: anywhere;
  font-family: Arial, sans-serif;
}

.status-chip {
  display: inline-flex;
  align-items: center;
  height: 26px;
  padding: 0 10px;
  border-radius: 5px;
  font-weight: 800;
  font-size: 13px;
  border: 1px solid transparent;
  white-space: nowrap;
}

.status-chip.pending {
  color: #d88a24;
  background: #fff7e8;
  border-color: #efd49d;
}

.status-chip.pass {
  color: #62b44b;
  background: #f0faea;
  border-color: #d9efcf;
}

.status-chip.reject {
  color: #e35b5b;
  background: #fff1f1;
  border-color: #f4caca;
}

.status-chip.invalid {
  color: #626b7a;
  background: #f0f3f7;
  border-color: #d9dee8;
}

.reason-text {
  margin-top: 8px;
  color: #e35b5b;
  font-size: 12px;
  line-height: 1.5;
  word-break: break-word;
}

.remark-cell {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
}

.remark-text {
  flex: 1;
  min-width: 0;
  color: #3b4351;
  line-height: 1.6;
  word-break: break-word;
}

.action-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.link-action {
  color: #3f7cff;
  font-weight: 700;
  white-space: nowrap;
}

.link-action.danger {
  color: #e35b5b;
}

.pager-wrap {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}

.log-pager {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.log-content {
  line-height: 1.7;
  white-space: pre-line;
  word-break: break-word;
}

.transfer-owner-current {
  margin-bottom: 16px;
  padding: 16px 18px;
  border: 1px solid #e6ebf2;
  border-radius: 8px;
  background: #f8fbff;
  color: #4f5868;
  line-height: 1.8;
}

.transfer-owner-current strong {
  color: #2e3542;
  font-weight: 800;
  word-break: break-word;
}

.transfer-owner-mode {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}

.transfer-owner-option {
  display: block;
  padding: 14px 16px;
  border: 1px solid #e6ebf2;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
}

.transfer-owner-option.is-active {
  border-color: #3f7cff;
  background: #f6f9ff;
  box-shadow: 0 0 0 2px rgba(63, 124, 255, .08);
}

.transfer-owner-option.is-disabled {
  border-color: #ebeef5;
  background: #f5f7fa;
  cursor: not-allowed;
}

.transfer-owner-option /deep/ .el-radio {
  display: flex;
  align-items: center;
  margin-right: 0;
  font-weight: 800;
  color: #2f3747;
}

.transfer-owner-option /deep/ .el-radio__label {
  color: inherit;
  font-weight: inherit;
}

.transfer-owner-option small {
  display: block;
  margin-top: 8px;
  padding-left: 24px;
  color: #7b8495;
  line-height: 1.6;
}

.transfer-owner-search {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.transfer-owner-search .el-input {
  flex: 1;
}

.transfer-owner-result {
  min-height: 48px;
  margin-bottom: 12px;
  padding: 12px 14px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: #f5f7fa;
  color: #626b7a;
  line-height: 1.6;
}

.transfer-owner-result.is-info {
  background: #f5f7fa;
  border-color: #e6ebf2;
}

.transfer-owner-result.is-success {
  color: #62b44b;
  background: #f0faea;
  border-color: #d9efcf;
}

.transfer-owner-result.is-error {
  color: #e35b5b;
  background: #fff1f1;
  border-color: #f4caca;
}

.transfer-owner-tip {
  color: #8b93a3;
  font-size: 12px;
  line-height: 1.7;
}

.remark-dialog-meta {
  margin-bottom: 16px;
  color: #4f5868;
  line-height: 1.7;
}

.remark-dialog-meta strong {
  color: #2e3542;
  font-weight: 800;
  word-break: break-word;
}

.remark-form-item {
  margin-bottom: 12px;
}

.remark-dialog-tip {
  color: #8b93a3;
  font-size: 12px;
  line-height: 1.7;
}

/deep/ .product-edit-drawer .el-drawer__body {
  padding: 20px;
  overflow-y: auto;
}

/deep/ .product-log-dialog .el-dialog__footer {
  padding-top: 10px;
}

/deep/ .product-remark-dialog .el-dialog__body {
  padding-top: 18px;
}

/deep/ .product-transfer-dialog .el-dialog__body {
  padding-top: 14px;
}

@media (max-width: 960px) {
  .transfer-owner-search {
    flex-direction: column;
    align-items: stretch;
  }

  .transfer-owner-option small {
    padding-left: 0;
  }
}
.vendor-list {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}
</style>
